<div class="download-file-confirmation-modal">
  @if (modalState$ | async) {
    <div class="overlay"></div>
  }
  <gc-modal
    [headerTitle]="'downloadFileConfirmationModal.title' | translate"
    [headerIcon]="'download'"
    [primaryButtonText]="'downloadFileConfirmationModal.proceed' | translate"
    [secondaryButtonText]="'downloadFileConfirmationModal.cancel' | translate"
    (closeModal)="closeModal()"
    (primaryButtonClicked)="proceedModal()"
    (secondaryButtonClicked)="closeModal()"
    ><div class="modal-content">
      <gc-text [variant]="'paragraphHeading'">{{
        'downloadFileConfirmationModal.body' | translate
      }}</gc-text>
      <gc-text [variant]="'body'" [textColor]="'utility'">{{
        (file$ | async)?.name ?? ''
      }}</gc-text>
    </div></gc-modal
  >
</div>
